// extracted by mini-css-extract-plugin
module.exports = {"zoomBoxContainer":"uHU-q","zoomIcon":"_380JK"};